var link_preview_default = {
  "fontElementMap": "KTpIk",
  "linkPreviewContainer": "prfgh",
  "linkPreview": "YBuwc",
  "linkPreviewImage": "HBkHA",
  "linkPreviewPlaceholder": "sk7uL",
  "linkPreviewInfo": "tingE",
  "linkPreviewTitle": "-uaW7",
  "linkPreviewDescription": "HfJ-y",
  "linkPreviewUrl": "_1-D0T",
  "linkPreviewResponsiveImage": "pWICY",
  "loadingContainer": "Rlb-N",
  "errorIcon": "lemLw",
  "errorInfo": "_1E1ya",
  "errorContainer": "hHGiK",
  "overlay": "osSBy",
  "thumbnailEnd": "bVZ9D",
  "thumbnailStart": "qJYtC",
  "thumbnailTop": "yFWqz"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
